define('helperComponent-getContentArray',[],function() {
    'use strict';

    var getContentArray = function(componentsJSON, kind) {
        var res = [];

        if (!componentsJSON || !kind || typeof kind !== 'string') {
            return res;
        }

        kind = kind.toLowerCase();

        for (var i = 0; i < componentsJSON.length; i++) {
            if (componentsJSON[i].kind && componentsJSON[i].kind && componentsJSON[i].kind.toLowerCase() === kind) {
                res.push(componentsJSON[i].content);
            }
        }

        return res;
    };

    return getContentArray;
});

